// extracted by mini-css-extract-plugin
module.exports = {"details":"_e0d04a","detailsEvenCategories":"_9b6311"};